import { Row, Col } from 'reactstrap'
import { IconChevronRight } from '@tabler/icons-react'

const LandingStepper = ({ menuItems, activeItemId }) => {
  return (
    <Row className="p-0 mt-1 mb-1">
      {menuItems?.map((item, index) => (
        <>
          <Col
            sm={3}
            md={3}
            lg={4}
            key={`step-${activeItemId}__${index + 1}`}
            className="d-flex align-items-center flex-direction-row">
            <div
              style={{
                background:
                  activeItemId === item.menuId ? 'var(--color-secondary)' : 'var(--color-primary)',
                borderRadius: '3px'
              }}>
              {item.icon}
            </div>
            <div className="d-flex ps-1 flex-column">
              <strong>{item.mainTitle}</strong>
              <span className="text-muted">{item.subTitle}</span>
            </div>
          </Col>
          {menuItems.length - 1 !== index && (
            <Col
              className="d-flex align-items-center"
              key={`chevron-${activeItemId}__${index + 1}`}
              sm={3}
              md={3}
              lg={3}>
              <IconChevronRight color="white" size={36} />
            </Col>
          )}
        </>
      ))}
    </Row>
  )
}

export default LandingStepper
